module.exports = ".container {\n  width: 100%;\n  color: white;\n  text-align: center;\n  padding: 0.25rem; }\n"